import { LinkButton, PublicButton } from '@yes.technology/react-toolkit'
import { getPublicButtonRest, isPublicButton } from 'shared/utils'
import { ActionButton } from 'site/Renderer/components/PartnerCardContainer/PartnerCardContainer.types'

export type PartnerCardButtonProps = {
  buttonConfig: ActionButton
}

const PartnerCardButton = ({ buttonConfig }: PartnerCardButtonProps) => {
  if (isPublicButton(buttonConfig)) {
    return (
      <PublicButton
        href={buttonConfig?.link?.url ?? buttonConfig?.href}
        target={buttonConfig?.link?.target ?? buttonConfig?.target}
        style={buttonConfig?.style}
        {...getPublicButtonRest(buttonConfig)}
      >
        {buttonConfig?.label}
      </PublicButton>
    )
  }

  return (
    <LinkButton
      href={buttonConfig?.link?.url}
      target={buttonConfig?.link?.target ?? '_self'}
      heightClass='small'
    >
      {buttonConfig.label}
    </LinkButton>
  )
}

export default PartnerCardButton
